import { selectQueryString } from '../../selectors/page';
import { selectPageMeta } from '../../selectors/seo';
import { IBrowserHistoryState } from '../../types/browserHistory';
import { TThunkAction } from '../../types/redux/thunk';
import { isBrowser } from '../../utils/isBrowser';
import { removeQueryStringFromLocation, isAllowedSearchQueryKey } from '../../utils/url';

export const updateBrowserHistory = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();

  const queryString = selectQueryString(state);
  const seoData = selectPageMeta(state);
  const title = seoData.title;

  const data: IBrowserHistoryState = {
    queryString,
  };

  if (isBrowser()) {
    const url = new URL(removeQueryStringFromLocation(window.location));

    const searchParams = new URLSearchParams(queryString);

    searchParams.forEach((value, key) => {
      if (isAllowedSearchQueryKey(key)) {
        url.searchParams.append(key, value);
      }
    });

    window.history.pushState(data, title, url);
  }
};
